import { createList } from 'shared/pages'
export default [
  {
    path: '',
    name: 'drug_list',
    component: () =>
      import('./List').then(config => createList(config.default)),
  },
  {
    path: 'new',
    name: 'drug_new',
    component: () => import('./New'),
  },
  {
    path: ':id',
    name: 'drug_detail',
    component: () => import('./Detail'),
    props: true,
  },
  {
    path: ':id/edit',
    name: 'drug_edit',
    component: () => import('./Edit'),
    props: true,
  },
]
